module.exports = __webpack_public_path__ + "media/images/service/b_3-e7d9ec55ee1704a91bcb34e6de76b5c7.png";